import { render, staticRenderFns } from "./ScreeningProcess.vue?vue&type=template&id=4d4da642&scoped=true&"
import script from "./ScreeningProcess.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcess.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProcess.vue?vue&type=style&index=0&id=4d4da642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4da642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCard,VChip,VCol,VIcon,VProgressLinear,VRow,VWindow,VWindowItem})
